import { Navigate, useLocation } from 'react-router-dom';
import routes from 'src/Resources/routes.json';
import { stashRedirect } from 'src/utils/postLoginRedirect';

/**
 * Drop-in replacement for <Navigate to={routes.login} /> on the unauthenticated catch-all route:
 * remembers the path the user actually asked for before sending them to the login screen, so
 * login.tsx can return them to it.
 *
 * Only the catch-all uses this. A bare "/" is not a destination worth restoring, and the login and
 * forgot-password routes are filtered out by stashRedirect itself.
 */
function RedirectToLogin() {
  const location = useLocation();

  // During render rather than in an effect: <Navigate> performs the navigation as this component
  // commits, so an effect would fire after the login screen has already replaced us.
  stashRedirect(location.pathname + location.search);

  return <Navigate to={routes.login} replace />;
}

export default RedirectToLogin;
